<!--  -->
<template>
    <div>
    <head-nav :key="Math.random()"/>
    <div class="page flex-col">
    <div class="main1 flex-col">
      <div class="bd1 flex-col">
        <div class="main2 flex-col"></div>
        <div class="main3 flex-col justify-center">
          <div class="main4">
            <span class="infoBox1">{{testpapertitle}}能力综合测试<br /></span>
            <span class="info1">认证成绩单</span>
          </div>
          <div class="main5 flex-col"></div>
        </div>
        <div class="main6 flex-col">
          <div class="group1 flex-col justify-between">
            <el-card class="box-card" v-if="global.isPhone()" >
              <el-descriptions title="个人信息" class="margin-top" :column="1" border>
                <el-descriptions-item>
                  <template slot="label">
                    姓名
                  </template>
                   {{name}}
                  </el-descriptions-item>
                  <el-descriptions-item>
                <template slot="label">
                    性别
                </template>
                  {{sex}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                   <template slot="label">
                    证件号码
                  </template>
                      {{numid}}
                  </el-descriptions-item>
                  <el-descriptions-item>
                  <template slot="label">
                    学号
                  </template>
                   {{cardid}}
                </el-descriptions-item>
                </el-descriptions>
                <el-descriptions title="考试信息" class="margin-top" style="margin-top:15px" :column="1" border v-if="score">
                <el-descriptions-item>
                  <template slot="label">
                    科目
                  </template>
                   {{testpapertitle}}
                  </el-descriptions-item>
                  <el-descriptions-item>
                <template slot="label">
                    考试时间
                </template>
                  {{examtime}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                   <template slot="label">
                    总分
                  </template>
                    100
                  </el-descriptions-item>
                  <el-descriptions-item>
                  <template slot="label">
                    最终得分
                  </template>
                   {{score}}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    培训方法
                  </template>
                   影音教学
                </el-descriptions-item>
                 <el-descriptions-item>
                  <template slot="label">
                    培训学时
                  </template>
                  {{classhour?classhour:'30'}}时
                </el-descriptions-item>
                </el-descriptions>
                <h4 style="margin-top: 15px;text-align:center;color:red;" v-else>未参加考试，如有疑问请联系系统管理员 </h4>
                <div class="main11 flex-row justify-between" style="    float: right;margin-top: 15px;margin-bottom: 15px;">
                  <span class="txt6"><a v-if="score"  :href="`https://www.cyrzpx.org.cn/achieveview/${recordid}`" style="color:#802bb2;font-weight:bold">查看试卷详情</a><a v-else :href="`https://www.cyrzpx.org.cn`" style="color:#802bb2;font-weight:bold">去参加考试</a></span>
                  <div class="layer2 flex-col"></div>
                </div>
            </el-card>

            <div class="layer1 flex-col align-center" v-else>
              <div class="box1 flex-col">
                <span class="info2">个人信息</span>
                <div class="main7 flex-col">
                  <div class="outer1 flex-row">
                    <span class="txt1">姓名</span>
                    <span class="info3">性别</span>
                    <span class="info4">证件号码</span>
                    <span class="txt2">学号</span>
                  </div>
                </div>
                <div class="main8 flex-row">
                  <span class="info5">{{name}}</span>
                  <span class="word1">{{sex}}</span>
                  <span class="txt3">{{numid}}</span>
                  <span class="word2">{{cardid}}</span>
                </div>
               
                <span class="txt4">考试信息</span>
                <div class="main9 flex-col" v-if="score">
                  <div class="mod1 flex-row">
                    <span class="info6">科目</span>
                    <span class="word3">考试时间</span>
                    <span class="txt5">总分</span>
                    <span class="word4">最终得分</span>
                    <span class="word5">培训方法</span>
                    <span class="word6">培训学时</span>
                  </div>
                </div>
                <div class="main10 flex-row" v-if="score">
                  <span class="word7">{{testpapertitle}}</span>
                  <span class="word8">{{examtime}}</span>
                  <span class="word9">100</span> 
                  <span class="info7">{{score}}</span>
                  <span class="word10">影音教学</span>
                  <span class="word11">{{classhour?classhour:'30'}}时</span>
                </div>
                <h4 v-else style="text-align: -webkit-center;margin-top: 10px;color:red;">未参加考试，如有疑问请联系系统管理员</h4>
                <div class="main11 flex-row justify-between">
                  <span class="txt6"><a v-if="score"  :href="`https://www.cyrzpx.org.cn/achieveview/${recordid}`" style="color:#802bb2;font-weight:bold">查看试卷详情</a><a v-else :href="`https://www.cyrzpx.org.cn`" style="color:#802bb2;font-weight:bold">去参加考试</a></span>
                  <div class="layer2 flex-col"></div>
                </div>
              </div>
              <div class="box2 flex-col"></div>
              <div class="box3 flex-col"></div>
              <div class="box4 flex-col"></div>
              <div class="box5 flex-col" ></div>
              <div class="box6 flex-col" v-if="score"></div>
              <div class="box7 flex-col" v-if="score"></div>
              <div class="box8 flex-col" v-if="score"></div>
              <div class="box9 flex-col" v-if="score"></div>
              <div class="box10 flex-col" v-if="score"></div>
              <div class="box11 flex-col" v-if="score"></div>
            </div>
            
            <div class="layer3 flex-col">
              <span class="word12"
                >创远认证&nbsp;&nbsp;&#64;京ICP备2022001465号-1</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    </div>
</template>

<script>
import global from "../components/PublicComs/Common.vue";
import HeadNav from "../components/PublicComs/HeadNav.vue";
export default {
  data () {
    return {
        bigQusts:[],
        paperInfo:{},
        global,
        name: "",
        cardid:"",
        testpapertitle:"",
        score: "",
        classhour: "",
        numid:"",
        sex:'',
        examtime:'',
        recordid:"",
    };
  },
  components: {HeadNav},

  computed:{},

  mounted(){
         let paperInfo = this.$route.query;
        this.cardid = paperInfo.cardid;

        this.$axios.get(`/api/users/findMeByCardId?cardid=${this.cardid}`).then(res => {
            if(res.data){
               let user= res.data.user;
               this.name = user.name;
               this.numid = user.identificationcard;
               this.sex = user.sex;
               this.classhour = user.studyhours;
               let examAchieveMent = res.data.examAchieveMent[0];
               this.score = examAchieveMent.score;
               this.testpapertitle= examAchieveMent.testpapertitle;
               let examRecord = res.data.examRecord;
               this.recordid = examRecord._id;
               this.examtime = examRecord.ctime;
               
            }
        });
  },

  methods: {
    //阿拉伯数字转中文数字
    NoToChinese(num) {
        if (!/^\d*(\.\d*)?$/.test(num)) {
            alert("Number is wrong!");
            return "Number is wrong!";
        }
        var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九");
        var BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
        var a = ("" + num).replace(/(^0*)/g, "").split("."),
            k = 0,
            re = "";
        for (var i = a[0].length - 1; i >= 0; i--) {
            switch (k) {
                case 0:
                    re = BB[7] + re;
                    break;
                case 4:
                    if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0]))
                        re = BB[4] + re;
                    break;
                case 8:
                    re = BB[5] + re;
                    BB[7] = BB[5];
                    k = 0;
                    break;
            }
            if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
            if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
            k++;
        }
        if (a.length > 1) //加上小数部分(如果有小数部分) 
        {
            re += BB[6];
            for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
        }
        return re;
    },
    print(){
        this.$print(this.$refs.print)
    }
  }
}

</script>
<style lang="scss" scoped>
.page {
  position: relative;
  width: 100%;
  // height: 1080px;
  overflow: hidden;
}

.main1 {
  // height: 1080px;
  // background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pso8qihx1zyvb6my8piyz74nblrbig7cthge41ff6a8-9735-468c-8be6-74f4fde81e8a)
  //   100% no-repeat;
  width: 100%;
}

.bd1 {
  width: 100%;
  // height: 1080px;
}

.main2 {
  width: 100%;
  height: 95px;
  // background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psqtnh0hof5wlahityi0zcie1bhkx0o9vfcb166d4bd-3f96-4065-8d0f-30b0a55a8416)
    // 0px -1px no-repeat;
}

.main3 {
  background-color: rgba(216, 239, 255, 1);
  z-index: 4;
  height: 286px;
  overflow: hidden;
  margin-top: 3px;
//   padding-left: 734px;
    text-align: center;
  width: 100%;
  position: relative;
}
 @media screen and (max-width: 640px) {
   .main3 {
   height: 187px;
   }
 }
.main4 {
  position: static;
  left: 734px;
  top: 197px;
//   width: 453px;
  height: 88px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: MicrosoftYaHei-Bold;
  text-align: center;
  line-height: 59px;
  white-space: nowrap;
}

.infoBox1 {
  width: 453px;
  height: 88px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 34px;
  font-family: MicrosoftYaHei-Bold;
  text-align: left;
  line-height: 59px;
  white-space: nowrap;
  font-weight: bold;
}

.info1 {
  width: 453px;
  height: 88px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 29px;
  font-family: MicrosoftYaHei;
  text-align: left;
  line-height: 59px;
  overflow: hidden;
  
  text-overflow: ellipsis;
}

.main5 {
  z-index: -1;
  position: absolute;
  left: 0;
  top: -0px;
  width: 1919px;
  height: 384px;
  background: url(/static/images/chuangyuan_banner.png)
    no-repeat;
}

.main6 {
  background-color: rgba(248, 248, 250, 1);
  // height: 696px;
  padding-top: 29px;
  width: 100%;
}

.group1 {
  width: 100%;
  // height: 667px;
}

.layer1 {
  background-color: rgba(255, 255, 255, 1);
  z-index: 8;
  height: 541px;
  margin: auto;
  padding-top: 26px;
  width: 1200px;
  position: relative;
}

.box1 {
  width: 1144px;
  height: 472px;
}

.info2 {
  width: 85px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 20px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  display: block;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
}

.main7 {
  background-color: rgba(240, 240, 240, 1);
  height: 58px;
  margin-top: 28px;
  width: 1144px;
  padding: 21px 0 0 122px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
}

.outer1 {
  width: 904px;
  height: 17px;
}

.txt1 {
  width: 36px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  display: block;
}

.info3 {
  width: 37px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 253px;
  display: block;
}

.info4 {
  width: 77px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 232px;
  display: block;
}

.txt2 {
  width: 36px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 233px;
  display: block;
}

.main8 {
  width: 930px;
  height: 14px;
  margin: 24px 0 0 114px;
}

.info5 {
  width: 44px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  display: block;
}

.word1 {
  width: 14px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin-left: 264px;
  display: block;
}

.txt3 {
  width: 175px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  display: block;
  margin: 1px 0 0 199px;
}

.word2 {
  width: 57px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  display: block;
  margin: 1px 0 0 177px;
}

.txt4 {
  width: 85px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 20px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 83px;
  display: block;
   font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
}

.main9 {
  background-color: rgba(240, 240, 240, 1);
  height: 58px;
  margin-top: 26px;
  width: 1144px;
  padding: 21px 0 0 75px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
}

.mod1 {
  width: 1009px;
  height: 18px;
}

.info6 {
  width: 36px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  display: block;
}

.word3 {
  width: 77px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 131px;
  display: block;
}

.txt5 {
  width: 37px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 145px;
  display: block;
}

.word4 {
  width: 76px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 136px;
  display: block;
}

.word5 {
  width: 77px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 112px;
  display: block;
}

.word6 {
  width: 77px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 105px;
  display: block;
}

.main10 {
  width: 1006px;
  height: 14px;
  margin: 24px 0 0 20px;
}

.word7 {
  width: 120px;
  height: 14px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  line-height: 14px;
  display: block;
}

.word8 {
  width: 147px;
  height: 12px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  line-height: 14px;
  display: block;
  margin: 1px 0 0 78px;
}

.word9 {
  width: 27px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  display: block;
  margin: 1px 0 0 114px;
}

.info7 {
  width: 18px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  display: block;
  margin: 1px 0 0 164px;
}

.word10 {
  width: 59px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin-left: 155px;
  display: block;
}

.word11 {
  width: 33px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin-left: 136px;
  display: block;
}

.main11 {
  width: 130px;
  height: 19px;
  margin: 84px 0 0 1003px;
}

.txt6 {
  width: 103px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(101, 20, 171, 1);
  font-size: 16px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 1px;
  display: block;
}

.layer2 {
  width: 11px;
  height: 19px;
  background: url(/static/images/right.png) -1px -1px
    no-repeat;
}

.box2 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 21;
  position: absolute;
  left: 312px;
  top: 77px;
  width: 1px;
  height: 116px;
}

.box3 {
  z-index: 24;
  position: absolute;
  left: 28px;
  top: 74px;
  width: 1143px;
  height: 119px;
  border: 1px solid rgba(209, 209, 209, 1);
}

.box4 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 22;
  position: absolute;
  left: 607px;
  top: 77px;
  width: 1px;
  height: 116px;
}

.box5 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 23;
  position: absolute;
  left: 902px;
  top: 77px;
  width: 1px;
  height: 116px;
}

.box6 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 39;
  position: absolute;
  left: 209px;
  top: 302px;
  width: 1px;
  height: 116px;
}

.box7 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 40;
  position: absolute;
  left: 405px;
  top: 302px;
  width: 1px;
  height: 116px;
}

.box8 {
  z-index: 44;
  position: absolute;
  left: 28px;
  top: 299px;
  width: 1143px;
  height: 119px;
  border: 1px solid rgba(209, 209, 209, 1);
}

.box9 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 42;
  position: absolute;
  left: 602px;
  top: 302px;
  width: 1px;
  height: 116px;
}

.box10 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 41;
  position: absolute;
  left: 798px;
  top: 302px;
  width: 1px;
  height: 116px;
}

.box11 {
  background-color: rgba(209, 209, 209, 1);
  z-index: 43;
  position: absolute;
  left: 994px;
  top: 302px;
  width: 1px;
  height: 116px;
}

.layer3 {
  background-color: rgba(49, 49, 49, 1);
  height: 38px;
  margin-top: 88px;
  width: 100%;
  // padding: 14px 0 0 753px;
}
@media screen and (max-width: 640px) {
  .layer3 {
     margin-top: 58px;
  }
}
.word12 {
  // width: 415px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(183, 183, 183, 1);
  font-size: 13px;
  font-family: PingFang-SC-Medium;
  text-align: center;
  white-space: nowrap;
  line-height: 13px;
  display: block;
  margin: auto;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}
body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
}
button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}
.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}
.justify-around {
  display: flex;
  justify-content: space-around;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-end {
  display: flex;
  align-items: flex-end;
}
.box-card{
  width: 95%;
  margin:auto;
}
::v-deep .el-descriptions-item__label.is-bordered-label{
  text-align: right !important;
    width: 35%;
}
@media screen and (max-width: 640px) {
  .info1{
        font-size: 25px;
        line-height: 21px;
        height: 88px;
  }
  .infoBox1{
        font-size: 30px;
            line-height: 30px;
            white-space: break-spaces;
  }
  .main4{
    height:138px;
  }
}
</style>